import React from 'react';
import PropTypes from 'prop-types';
import { ReactSVG } from 'react-svg';
import { graphql, useStaticQuery } from 'gatsby';

import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';

import AppDownload from '../AppDownload';
import { Container, Link } from '../theme';
import SocialLinks from '../SocialLinks';
import Logo from '../../assets/images/logo/logo_komm-kickern_small.svg';

function FooterColumn({ headline, links }) {
  if (!links || links.length === 0) {
    return null;
  }

  return (
    <Grid item xs={12} sm={4} lg={3}>
      <Typography
        variant="h1"
        gutterBottom
        sx={(theme) => ({
          fontStyle: 'italic',
          letterSpacing: 'normal',
          textTransform: 'uppercase',
          fontSize: theme.typography.pxToRem(18),
        })}
      >
        {headline}
      </Typography>
      <Box component="ul" sx={{ margin: '0', listStyle: 'none', padding: '0' }}>
        {links.map(({ id, DisplayTitle, url }) => (
          <Box
            component="li"
            sx={(theme) => ({ paddingTop: theme.spacing(1), paddingBottom: theme.spacing(0.5) })}
            key={id}
          >
            <Link variant="inherit" underline="none" color="inherit" to={url}>
              {DisplayTitle}
            </Link>
          </Box>
        ))}
      </Box>
    </Grid>
  );
}

FooterColumn.propTypes = {
  headline: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  links: PropTypes.arrayOf(PropTypes.any).isRequired,
};

function Footer() {
  const data = useStaticQuery(graphql`
    query {
      allStrapiFooterMenu {
        nodes {
          FooterMenuGroups {
            menuLinks {
              DisplayTitle
              url
              id
            }
            title
            id
          }
        }
      }
    }
  `);

  return (
    <>
      <AppDownload />
      <Typography
        variant="body1"
        component="footer"
        color="textSecondary"
        sx={(theme) => ({
          display: 'flex',
          backgroundColor: theme.palette.grey[900],
          color: theme.palette.common.white,
          marginBottom: '0',
        })}
      >
        <Container sx={(theme) => ({ marginTop: theme.spacing(8), marginBottom: theme.spacing(1) })}>
          <Grid
            container
            sx={(theme) => ({
              [theme.breakpoints.down('lg')]: {
                gap: 5,
              },
            })}
          >
            <Grid container xs={12} sm={12} lg={4} spacing={3}>
              <Grid xs={6} sm={8} lg={3}>
                <ReactSVG
                  beforeInjection={(svg) => {
                    svg.setAttribute('style', 'width: 20px; height: 41px;');
                  }}
                  src={Logo}
                />
              </Grid>
              <Grid
                xs={6}
                sm={4}
                lg={9}
                sx={(theme) => ({
                  textAlign: 'right',
                  [theme.breakpoints.up('sm')]: {
                    textAlign: 'left',
                  },
                })}
              >
                <SocialLinks />
              </Grid>
            </Grid>
            <Grid
              container
              xs={12}
              sm={12}
              lg={8}
              sx={(theme) => ({
                [theme.breakpoints.down('sm')]: {
                  gap: 10,
                },
                [theme.breakpoints.up('lg')]: {
                  gap: 5,
                },
              })}
              justifyContent="flex-end"
            >
              {data.allStrapiFooterMenu.nodes[0].FooterMenuGroups.map((linkSection) => {
                return <FooterColumn key={linkSection.id} headline={linkSection.title} links={linkSection.menuLinks} />;
              })}
            </Grid>
          </Grid>
          <Typography
            variant="body1"
            sx={(theme) => ({
              color: '#878787',
              fontSize: theme.typography.pxToRem(16),
              marginTop: theme.spacing(10),
              textAlign: 'center',
              [theme.breakpoints.up('md')]: {
                textAlign: 'left',
              },
            })}
          >
            Copyright © 2019-{new Date().getFullYear()} Komm Kickern - All Rights Reserved
          </Typography>
        </Container>
      </Typography>
    </>
  );
}

export default Footer;
